import { useTranslation } from 'react-i18next';

import { SidePanelSectionTabSt } from '~organisms/SidePanelSectionTab';

interface CornerRadiusConstraintModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CornerRadiusConstraintModal = ({
  isOpen,
  onClose,
}: CornerRadiusConstraintModalProps) => {
  const { t } = useTranslation();

  return (
    <SidePanelSectionTabSt.RemoveOptionModal
      open={isOpen}
      onCancel={onClose}
      footer={
        <SidePanelSectionTabSt.RemoveOptionModalCloseBtn onClick={onClose}>
          {t('COMMON.CLOSE')}
        </SidePanelSectionTabSt.RemoveOptionModalCloseBtn>
      }
    >
      <SidePanelSectionTabSt.RemoveOptionModalTitle>
        {t('DESIGN_SIDE_PANEL.CORNER_RADIUS.CONSTRAINT_MODAL.TITLE')}
      </SidePanelSectionTabSt.RemoveOptionModalTitle>
      <SidePanelSectionTabSt.RemoveOptionModalDescription>
        {t('DESIGN_SIDE_PANEL.CORNER_RADIUS.CONSTRAINT_MODAL.DESCRIPTION')}
      </SidePanelSectionTabSt.RemoveOptionModalDescription>
    </SidePanelSectionTabSt.RemoveOptionModal>
  );
};

export default CornerRadiusConstraintModal;
